import { render, staticRenderFns } from "./DollarDisplay.vue?vue&type=template&id=67c89169&scoped=true&"
import script from "./DollarDisplay.vue?vue&type=script&lang=js&"
export * from "./DollarDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DollarDisplay.vue?vue&type=style&index=0&id=67c89169&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c89169",
  null
  
)

export default component.exports